import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function addRichiestaRecupero(
  username,
  token,
  idLezioneRecupero,
  idRichiestaRecupero,
  note = "",
  idSessione = null
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "addRichiestaRecupero.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        const bodyString = body.toString();

        console.log(
          "[addRichiestaRecupero] Risposta grezza dal server:",
          bodyString
        );

        // Gestisci risposte vuote o non valide
        if (!bodyString || bodyString.trim() === "") {
          console.warn("addRichiestaRecupero: Risposta vuota dal server");
          resolve({ success: false, message: "Risposta vuota dal server" });
          return;
        }

        try {
          const resp = JSON.parse(bodyString);
          console.log("[addRichiestaRecupero] Risposta parsata:", resp);
          resolve(resp);
        } catch (error) {
          console.error("addRichiestaRecupero: Errore parsing JSON:", error);
          console.error("Risposta ricevuta:", bodyString);
          resolve({
            success: false,
            message: "Errore nel parsing della risposta",
            raw: bodyString,
          });
        }
      });

      res.on("error", function(error) {
        console.error(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: username,
      id_lezione_recupero: idLezioneRecupero,
      id_richiesta_recupero: idRichiestaRecupero,
      note: note || "", // PDO prepared statements gestiscono automaticamente l'escaping
      id_sessione: idSessione, // AGGIUNTO: Per recuperi parziali (mezza giornata)
    });

    console.log("[addRichiestaRecupero] Dati inviati:", {
      id_lezione_recupero: idLezioneRecupero,
      id_richiesta_recupero: idRichiestaRecupero,
      note: note,
      id_sessione: idSessione,
      hasToken: !!token,
      hasUsername: !!username,
    });

    req.write(postData);

    req.end();
  });
}
